// extracted by mini-css-extract-plugin
export var cancelButton = "_pn-5";
export var content = "_pn-3";
export var createButton = "_pn-6";
export var drawerContainer = "_pn-0";
export var footer = "_pn-2";
export var header = "_pn-1";
export var orderFormColumn = "_pn-4";